/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CompartmentDetailsBase {
    type: string;

    protected setDiscriminator(type: string) {
        this.type = type;
    }

    getFixupPrototypeFunction() { return CompartmentDetailsBase.fixupPrototype; }

    static newInstance(model: Partial<CompartmentDetailsBase>): CompartmentDetailsBase {
        let obj = Object.assign(new CompartmentDetailsBase(), model);
        CompartmentDetailsBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CompartmentDetailsBase>): CompartmentDetailsBase {
        if (!model) return null;
        return CompartmentDetailsBase.newInstance(<CompartmentDetailsBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CompartmentDetailsBase) {
        if (!obj) return;

        models.CompartmentDetailsBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CompartmentDetailsBase): boolean {
        switch (obj.type)
        {
            case "CompartmentDetailsForOCI":
                Object.setPrototypeOf(obj, models.CompartmentDetailsForOCI.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof CompartmentDetailsBase)[] {
        return [
            models.CompartmentDetailsForOCI,
        ];
    }

    fixupFields() {
    }

    /**
     * Unique Id
     */
    compartment_id: string;

    /**
     * Display Name
     */
    name: string;

    /**
     * Description
     */
    description: string;

    /**
     * Parent Compartment Id
     */
    parent_id: string;

}
